import styled from "styled-components";

const Root = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`;

const Filters = styled.div`
  display: flex;
`;

const Filter = styled.div``;

export const TableActions = Object.assign(Root, { Filters, Filter });
